var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card-tree-skeleton"},[_c('div',{staticClass:"card-header"},[_c('tree-skeleton',{attrs:{"lines":1}})],1),_c('div',{staticClass:"card-body"},[_c('tree-skeleton',{attrs:{"lines":3}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }